"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames7 = _interopRequireDefault(require("classnames"));
var _useAutocomplete2 = _interopRequireDefault(require("@material-ui/lab/useAutocomplete"));
var _Close = _interopRequireDefault(require("mdi-material-ui/Close"));
var _MenuDown = _interopRequireDefault(require("mdi-material-ui/MenuDown"));
var _MenuUp = _interopRequireDefault(require("mdi-material-ui/MenuUp"));
var _Alert = _interopRequireDefault(require("mdi-material-ui/Alert"));
var _Check = _interopRequireDefault(require("mdi-material-ui/Check"));
var _ComboBox = _interopRequireDefault(require("./ComboBox.styles"));
var _excluded = ["onDelete"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ComboBox = function ComboBox(_ref) {
  var _classnames3, _classnames4;
  var label = _ref.label,
    multiple = _ref.multiple,
    description = _ref.description,
    hasError = _ref.hasError,
    id = _ref.id,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    options = _ref.options,
    onChange = _ref.onChange,
    filterSelectedOptions = _ref.filterSelectedOptions,
    filterOptions = _ref.filterOptions,
    defaultValue = _ref.defaultValue,
    valueProp = _ref.value,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  var classes = (0, _ComboBox.default)();
  var rootEl = (0, _react.useRef)(null);
  var _useAutocomplete = (0, _useAutocomplete2.default)({
      id: id,
      options: options,
      multiple: multiple,
      defaultValue: defaultValue,
      filterSelectedOptions: filterSelectedOptions,
      value: valueProp,
      filterOptions: filterOptions,
      getOptionLabel: function getOptionLabel(option) {
        return option.title;
      },
      onChange: onChange
    }),
    getRootProps = _useAutocomplete.getRootProps,
    getInputLabelProps = _useAutocomplete.getInputLabelProps,
    getInputProps = _useAutocomplete.getInputProps,
    getListboxProps = _useAutocomplete.getListboxProps,
    getOptionProps = _useAutocomplete.getOptionProps,
    getClearProps = _useAutocomplete.getClearProps,
    groupedOptions = _useAutocomplete.groupedOptions,
    getTagProps = _useAutocomplete.getTagProps,
    value = _useAutocomplete.value,
    focused = _useAutocomplete.focused,
    setAnchorEl = _useAutocomplete.setAnchorEl;

  // MISC
  var labelProps = getInputLabelProps();
  var _getInputProps = getInputProps(),
    onMouseDown = _getInputProps.onMouseDown,
    onBlur = _getInputProps.onBlur;
  var _getClearProps = getClearProps(),
    onClear = _getClearProps.onClick;
  var rootProps = getRootProps();

  // EVENTS
  var handleKeyDownOnTag = function handleKeyDownOnTag(event, onDelete) {
    if (event.key === 'Enter') {
      onDelete();
    }
  };
  var handleInputKeyDown = function handleInputKeyDown(event) {
    if (event.key === 'Enter' && !disabled) {
      onMouseDown();
    }
  };
  var handleMenuDownClick = function handleMenuDownClick(event) {
    if (!disabled) {
      onMouseDown();
    }
  };
  var handleMenuUpClick = function handleMenuUpClick(event) {
    if (!disabled) {
      onBlur();
    }
  };
  var handleClearAll = function handleClearAll() {
    onClear();
  };
  var hasValue = function hasValue() {
    if (multiple) {
      if (value.length > 0) {
        return true;
      }
    } else if (value) {
      return true;
    }
    return false;
  };

  // STYLES
  var cssListbox = (0, _classnames7.default)(classes.listbox, _defineProperty({}, classes.listboxWithDescription, description));
  var cssDescription = (0, _classnames7.default)(classes.description, _defineProperty({}, classes.descriptionInvalid, hasError));
  var cssInputWrapper = (0, _classnames7.default)(classes.inputWrapper, (_classnames3 = {}, _defineProperty(_classnames3, classes.inputWrapperInvalid, hasError), _defineProperty(_classnames3, classes.inputWrapperDisabled, disabled), _defineProperty(_classnames3, classes.inputWrapperFocused, focused), _classnames3));
  var cssLabel = (0, _classnames7.default)(classes.label, (_classnames4 = {}, _defineProperty(_classnames4, classes.labelInvalid, hasError), _defineProperty(_classnames4, classes.labelDisabled, disabled), _defineProperty(_classnames4, classes.labelFocused, focused), _classnames4));
  var cssCaretIcon = (0, _classnames7.default)(classes.caretIcon, _defineProperty({}, classes.caretUp, rootProps['aria-expanded']));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    tabIndex: disabled ? -1 : 0,
    role: "button",
    onKeyDown: handleInputKeyDown
  }, /*#__PURE__*/_react.default.createElement("div", _extends({}, getRootProps(), {
    ref: rootEl
  }), /*#__PURE__*/_react.default.createElement("label", _extends({
    className: cssLabel,
    htmlFor: labelProps.htmlFor
  }, labelProps), label, required && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.required
  }, " *")), /*#__PURE__*/_react.default.createElement("div", {
    ref: setAnchorEl,
    className: cssInputWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.inputValueContainer
  }, multiple && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.map(function (option, index) {
    var _getTagProps = getTagProps({
        index: index
      }),
      onDelete = _getTagProps.onDelete,
      props = _objectWithoutProperties(_getTagProps, _excluded);
    return /*#__PURE__*/_react.default.createElement("div", _extends({
      className: classes.tag
    }, props, {
      key: option.title,
      tabIndex: 0,
      role: "button",
      onKeyDown: function onKeyDown(e) {
        return handleKeyDownOnTag(e, onDelete);
      }
    }), /*#__PURE__*/_react.default.createElement("span", null, option.title), /*#__PURE__*/_react.default.createElement(_Close.default, {
      onClick: onDelete
    }));
  })), /*#__PURE__*/_react.default.createElement("input", _extends({
    disabled: disabled,
    placeholder: hasValue() ? '' : placeholder
  }, getInputProps()))), hasValue() && !disabled && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.clearAll,
    onClick: handleClearAll,
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    fontSize: "inherit"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: cssCaretIcon
  }, rootProps['aria-expanded'] ? /*#__PURE__*/_react.default.createElement(_MenuUp.default, {
    onClick: handleMenuUpClick
  }) : /*#__PURE__*/_react.default.createElement(_MenuDown.default, {
    onClick: handleMenuDownClick
  }))), description && /*#__PURE__*/_react.default.createElement("div", {
    className: cssDescription
  }, hasError && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    fontSize: "inherit"
  }), /*#__PURE__*/_react.default.createElement("span", null, description))), groupedOptions.length > 0 ? /*#__PURE__*/_react.default.createElement("ul", _extends({
    className: cssListbox
  }, getListboxProps(), {
    style: {
      width: rootEl.current.clientWidth
    }
  }), groupedOptions.map(function (option, index) {
    var selectedValue = '';
    if (value) {
      selectedValue = value.value;
    }
    var isSelected = selectedValue === option.value;
    var cssOption = (0, _classnames7.default)(_defineProperty({}, classes.optionSelected, isSelected));
    return /*#__PURE__*/_react.default.createElement("li", _extends({
      className: cssOption,
      key: option.title
    }, getOptionProps({
      option: option,
      index: index
    })), option.title, isSelected && /*#__PURE__*/_react.default.createElement("span", {
      className: classes.iconSelected
    }, /*#__PURE__*/_react.default.createElement(_Check.default, {
      fontSize: "inherit"
    })));
  })) : null);
};
var _default = ComboBox;
exports.default = _default;